<!-- eslint-disable -->
<template lang="pug">
    .setting(:class="{'setting_is-disabled': disabled}")
        svg-icon(
            name="angle-left",
            :aria-hidden="true",
            height="11",
            width="7",
            @click.native="decrease",
            :class="{'arrow_is-disabled': min === value}"
        )
        .setting__label
            | {{ label }}
        svg-icon(
            name="angle-right",
            :aria-hidden="true",
            height="11",
            width="7",
            @click.native="increase",
            :class="{'arrow_is-disabled': max === value}"
        )
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            label: {
                type: [String, Number],
                default: '',
            },
            value: {
                type: [Number, String],
                default: 0,
            },
            min: {
                type: Number,
                default: 0,
            },
            max: {
                type: Number,
                default: 0,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            increase () {
                this.value !== this.max && this.$emit('increase');
            },
            decrease () {
                this.value !== this.min && this.$emit('decrease');
            }
        }
    }
</script>

<style scoped lang="scss">
    .setting {
        height: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 0;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        margin-right: 5px;
        @include media($xl) {
            margin-right: 8px;
        }
        &:last-child {
            margin-right: 0;
        }
        .svg-icon {
            cursor: pointer;
            color: #2187FF;
            margin: 0 5px;
            @include media($xl) {
                margin: 0 8px;
            }
        }
    }
    .setting_is-disabled {
        pointer-events: none;
        cursor: auto;
        opacity: .7;
        .svg-icon {
            cursor: auto;
            color: $hsl-color-gray-74;
        }
    }
    .setting__label {
        user-select: none;
        pointer-events: none;
        font-size: 14px;
    }
    .arrow_is-disabled  {
        cursor: auto;
        pointer-events: none;
        color: $hsl-color-gray-74 !important;
    }
</style>
